import { type ComponentProps, type Ref } from 'react';

import { TreeItem, TreeItemButton, type TreeItemButtonProps, type TreeItemProps } from '@air/component-tree';
import { CheckIcon } from '@air/design-icons';
import { Tooltip } from '@air/primitive-tooltip';

export type BoardSelectListItemProps = Pick<ComponentProps<'div'>, 'children'> &
  Pick<TreeItemProps, 'onOpenChange' | 'prefix' | 'suffix'> &
  Pick<TreeItemButtonProps, 'disabled'> & {
    disabledMessage?: string;
    id: string;
    isExpanded?: boolean;
    isSelected?: boolean;
    onSelect?: () => void;
    rowRef?: Ref<HTMLDivElement>;
    title: string;
  };

export const BoardSelectListItem = ({
  children,
  disabled,
  disabledMessage,
  id,
  isExpanded,
  isSelected,
  onSelect,
  onOpenChange,
  prefix,
  rowRef,
  suffix,
  title,
}: BoardSelectListItemProps) => {
  return (
    <div data-testid="BOARD_SELECT_LIST_ITEM" data-id={id} data-title={title}>
      <TreeItem
        data-id={id}
        onOpenChange={onOpenChange}
        open={isExpanded}
        prefix={prefix}
        ref={rowRef}
        size="small"
        state={isSelected ? 'selected' : 'default'}
        suffix={
          <div className="flex items-center gap-1">
            {isSelected && (
              <div className="flex size-4 items-center justify-center rounded-full bg-blue-3">
                <CheckIcon size="xs" className="text-blue-11" />
              </div>
            )}
            {suffix}
          </div>
        }
      >
        <Tooltip label={disabled && disabledMessage ? disabledMessage : undefined}>
          <TreeItemButton className={disabled ? 'opacity-40' : 'opacity-100'} disabled={disabled} onClick={onSelect}>
            {title}
          </TreeItemButton>
        </Tooltip>
      </TreeItem>

      {!!children && isExpanded && <div className="pl-6">{children}</div>}
    </div>
  );
};
